var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"loader",class:_vm.data.staticClass},'div',Object.assign({}, _vm.data.attrs, ( _obj = {}, _obj[_vm.parent.$options._scopeId] = '', _obj )),false),_vm.listeners),[_c('i',{staticClass:"fas fa-spinner fa-pulse"})])}
var staticRenderFns = []

export { render, staticRenderFns }